export default "__VITE_ASSET__QRzTf5Gf__"